<script type="text/jsx">
import _ from 'lodash';
import { planUnitMap } from '@/common/product-unit';
import SaveCount from '@/components/save-count';
import CycleSelect from '@/components/service/cycle-select.vue';
import OpcOption from '@/components/zoom-ui-plus/select/option.vue';
import ConfigTextRow from '@/plans/EVENT_SAAS/component/config-text-row.vue';
import { capitalizeFirstLetter } from '@/common/utils';
import { BILLING_CYCLE } from '@/common/constants';
const CycleSort = {
  [BILLING_CYCLE.MONTHLY]: 4,
  [BILLING_CYCLE.ANNUAL]: 3,
  [BILLING_CYCLE.ONE_MONTH]: 2,
  [BILLING_CYCLE.ONE_TIME]: 1,
};
export default {
  name: 'config-cycle-v2',
  components: { SaveCount, CycleSelect, OpcOption, ConfigTextRow },
  model: {
    prop: 'billingCycle',
    event: 'syncCycle',
  },
  props: {
    // billing cycle plan list
    billingCycleList: {
      type: Array,
      required: true,
      default: () => [],
    },
    billingCycle: String,
    unit: {
      type: Number,
      default: planUnitMap.license,
      validator: function(v) {
        return _.chain(planUnitMap)
          .values()
          .includes(v)
          .value();
      }
    },
    trackingPlanName: {
      type: String,
      required: false,
      default: '',
    },
    billingCycleGroupOptions: {
      type: Object,
      default: () => ({})
    },
    planName: {
      type: String,
      required: false,
      default: '',
    },
    textViewModel: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      newPlan: {},
      oldPlan: {}
    }
  },
  computed: {
    currentPlanList() {
      return _.map(this.billingCycleList, (p) => p.plan);
    },
    currentGroupPlanList() {
      return this.billingCycleGroupOptions.map(plan => {
        return plan.options.map(p => p.plan);
      }).flat();
    },
    groupByPlanListByCycle() {
      return _.groupBy(this.currentPlanList, (p) => p?.billing_cycle);
    },
    cartSelectedPlan() {
      return _.find(this.currentPlanList, (p) => p?.cartInfo?.selected_number > 0);
    },
    cartSelectedPlanCode() {
      return this.cartSelectedPlan?.plan_code;
    },
    billingCycleOptions() {
      const cycleMap = {
        [BILLING_CYCLE.MONTHLY]: `${this.$t('billing.billing_cycle.monthly')} ${this.$t('billing.billing_cycle.subscription')}`,
        [BILLING_CYCLE.ANNUAL]: `${capitalizeFirstLetter(this.$t('billing.billing_cycle.annual'))} ${this.$t('billing.billing_cycle.subscription')}`,
        [BILLING_CYCLE.ONE_MONTH]: `${this.$t('billing.billing_cycle.one_month_new')}`,
        [BILLING_CYCLE.ONE_TIME]: `${this.$t('billing.billing_cycle.one_time')}`,
        [BILLING_CYCLE.TWO_YEARS]: `${this.$t('billing.billing_cycle.two_years')}`,
        [BILLING_CYCLE.THREE_YEARS]: `${this.$t('billing.billing_cycle.three_years')}`,
        [BILLING_CYCLE.QUARTERLY]: `${this.$t('billing.billing_cycle.quarterly')}`,
      };
      return this.billingCycleGroupOptions.map((group) => {
        return {
          ...group,
          options: group.options.reduce((prev,cur) => {
            const { plan, disabled, tooltips } = cur;
            prev.push({
              ...plan,
              disabled,
              tooltips,
              cycleLabel: cycleMap[plan.billing_cycle]
            });
            return prev;
          }, []).sort((a,b) => {
            if (CycleSort[a.billing_cycle] < CycleSort[b.billing_cycle]) {
              return 1;
            }
            if (CycleSort[a.billing_cycle] > CycleSort[b.billing_cycle]) {
              return -1;
            }
            return 0;
          })
        }
      })
    },
  },
  methods: {
    switchBillingCycle(oldPlan, newPlan) {
      console.log(oldPlan,newPlan);
      this.oldPlan = oldPlan;
      this.newPlan = newPlan;
      this.$emit("switchCycleAction", oldPlan, newPlan);
    },
    changeBillingCycle(cycle) {
      this.$emit("syncCycle", cycle, this.oldPlan, this.newPlan);
    },
  },
  render() {
    const label = `${this.planName} Plan`;

    if (this.textViewModel) {
      return <config-text-row title={this.$t('billing.plan')} value={this.billingCycleOptions?.[0]?.options?.[0]?.cycleLabel} />
    }

    return <div class='opc-select-cycle'>
      <cycle-select
        inline-label={this.$t('billing.plan')}
        popper-append-to-body
        value={this.billingCycle}
        plans={this.currentGroupPlanList}
        aria-label={label}
        label={label}
        action={this.switchBillingCycle}
        onInput={this.changeBillingCycle}
        className="opc-capacity-config-row__capacity--select"
        popper-class='opc-capacity-config-row__capacity--popper'>
        {this.billingCycleOptions.map((group) => {
          return <zm-option-group
            key={group.label}
            label={group.label}>
            {group.options.map((p) => {
              return <opc-option
                key={p.billing_cycle}
                value={p.billing_cycle}
                label={p.cycleLabel}
                disabled={p.disabled}
                tooltip-content={p.tooltips}
              />;
            })}
          </zm-option-group>
        })}
      </cycle-select>
    </div>;
  },
};
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';
.opc-capacity-config-row__capacity--popper {
  .zm-select-dropdown__wrap.zm-scrollbar__wrap {
    max-height: unset !important;
  }
  .zm-select-group__title {
    padding-left: 8px;
  }
  .zm-select-group__wrap:not(:last-of-type)::after {
    left: 8px;
    right: 8px;
  }
}
.opc-select-cycle {
  margin-left: 16px;
  @include media(mobile, tablet) {
    margin-left: 0;
    margin-top: 16px;
  }
  .zm-select.zm-select--xLarge {
    height: 48px;
    min-width: 200px;
  }

  .zm-select-group__title {
    padding-left: 8px;
  }
}
</style>
